import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE } from "@/constants";

export const accountModule = {
  state: {
    isLoggedIn: false,
    account: null,
  },
  mutations: {
    setAccount(state, account) {
      state.isLoggedIn = true;
      state.account = account;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.account = null;
    },
  },
  actions: {
    [ACTION_TYPES.GET_ME]: {
      root: true,
      async handler({ dispatch }) {
        const response = await dispatch(ACTION_TYPES.CALL_API, {
          url: "me/",
          opt: { throw_error: true },
        });
        dispatch(ACTION_TYPES.SET_ME, response.body.account);
        return response;
      },
    },
    [ACTION_TYPES.SET_ME]: {
      root: true,
      handler({ commit }, account) {
        commit("setAccount", account);
      },
    },
    [ACTION_TYPES.LOGIN]: {
      root: true,
      async handler({ dispatch }, params) {
        try {
          const response = await dispatch(ACTION_TYPES.CALL_API, {
            url: "login/",
            params,
            opt: { throw_error: true },
          });
          dispatch(ACTION_TYPES.SET_ME, response.body.account);
          return response;
        } catch (e) {
          return e;

          // console.log(e);
          // if (e.status === 400 && response.body.msg === 'password_expired') {
          //
          // }
        }
      },
    },
    [ACTION_TYPES.LOGOUT]: {
      root: true,
      async handler({ commit, dispatch }) {
        dispatch(ACTION_TYPES.CALL_API, {
          url: "logout/",
          params: {},
          opt: { throw_error: true },
        });

        commit("logout");
      },
    },
  },
  getters: {
    account(state) {
      return state.account;
    },
    hasPermission:
      (state) =>
      (permission, is_rbu = false) => {
        if (state.account) {
          if (is_rbu) {
            return (
              [USER_TYPE.SUPER_ADMIN].indexOf(state.account.type) !== -1 ||
              state.account.permissions.indexOf(permission) !== -1
            );
          } else {
            return (
              [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].indexOf(
                state.account.type
              ) !== -1 || state.account.permissions.indexOf(permission) !== -1
            );
          }
        }
        return false;
      },

    hasSpecialPermission: (state) => (permission) => {
      if (state.account) {
        return (
          [USER_TYPE.SUPER_ADMIN].indexOf(state.account.type) !== -1 ||
          state.account.special_permissions.indexOf(permission) !== -1
        );
      }
      return false;
    },
  },
};
